import React from "react"
import { graphql } from "gatsby"
import ModalWrapper from "./modal-wrapper"
import Form from "../forms/form"

export const query = graphql`
  fragment ModalFields on DatoCmsModal {
    componentId: key
    title
    preamble
    formreference {
      ...FormFields
    }
  }
`

interface ModalProps extends Queries.ModalFieldsFragment {
  id: string
  buttonText: string
  plainCta?: boolean
}

const Modal = (props: ModalProps) => {
  return (
    <>
      <ModalWrapper
        id={props.id}
        title={props.title}
        buttonText={props.buttonText}
        plainCta={props.plainCta ? props.plainCta : false}
      >
        {props.title && !props.formreference && (
          <h2 className="c-heading--b c-modal__title -with-dash">
            {props.title}
          </h2>
        )}
        {props.preamble && !props.formreference && (
          <div className="c-modal__preamble">{props.preamble}</div>
        )}
        {props.formreference && (
          <Form
            alternateTitle={props.title}
            alternatePreamble={props.preamble}
            standalone={false}
            {...props.formreference}
          />
        )}
      </ModalWrapper>
    </>
  )
}

export default Modal
